import { useState } from "react";

import OpenMenuButton from "@app/analytics/components/OpenMenuButton";
import TableCell from "@app/analytics/components/Table/TableCell";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import MenuItem from "../../components/MenuItem";
import RemoveTeamMemberConfirmationModal from "../RemoveTeamMemberConfirmationModal";

const TeamMenuCell = ({
  disabled,
  onRemove,
  showConfirmation,
}: {
  disabled: boolean;
  onRemove: () => void;
  showConfirmation: boolean;
}) => {
  const [confirmationOpen, setConfirmationOpen] = useState<boolean>(false);
  const anchorElement = useAnchorElement();

  const closeConfirmationModal = () => setConfirmationOpen(false);
  const handleConfirm = () => {
    onRemove();
    closeConfirmationModal();
  };

  const handleRemoveClick = () => {
    if (showConfirmation) {
      setConfirmationOpen(true);
      anchorElement.onClose();
    } else {
      handleConfirm();
    }
  };

  return (
    <>
      <RemoveTeamMemberConfirmationModal
        open={confirmationOpen}
        onClose={closeConfirmationModal}
        onConfirm={handleConfirm}
      />
      <TableCell sx={{ width: "50px" }}>
        <OpenMenuButton
          {...anchorElement}
          disabled={disabled}
          id="remove-member-from-team"
          menuItems={[
            <MenuItem key="remove" onClick={handleRemoveClick}>
              Remove from Team
            </MenuItem>,
          ]}
          MenuProps={{
            anchorOrigin: { horizontal: "right", vertical: "bottom" },
            transformOrigin: { horizontal: "right", vertical: "top" },
          }}
        />
      </TableCell>
    </>
  );
};

export default TeamMenuCell;
